import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ParrotBaseComponent } from '../parrot-base/parrot-base.component';

@Component({
  selector: 'app-none-login-footer',
  templateUrl: './none-login-footer.component.html',
  styleUrls: ['./none-login-footer.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class NoneLoginFooterComponent extends ParrotBaseComponent implements OnInit, OnDestroy {
  constructor(public deviceService: DeviceDetectorService) {
    super(deviceService);
  }

  ngOnInit(): void {}
}
